import { Component } from '@angular/core';
import { DefaultEditor } from 'ng2-smart-table';

@Component({
  template: `
    <input type="number" [ngClass]="inputClass" class="form-control form-control-sm" [(ngModel)]="cell.newValue" [name]="cell.getId()" [placeholder]="cell.getTitle()" [disabled]="!cell.isEditable()" (click)="onClick.emit($event)" (keydown.enter)="onEdited.emit($event)"
          (keydown.esc)="onStopEditing.emit()">
    `
})
export class NumericEditorComponent extends DefaultEditor {

  constructor() {
    super();
  }
}
